import { Button, SeverityBadge } from '@sitewise/ui';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import { fetchVendorWorkOrder } from '../../api/vendor-work-orders.js';

export function VendorWorkDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useQuery({
    queryKey: ['vendor', 'work-order', id],
    queryFn: () => fetchVendorWorkOrder(id!),
    enabled: Boolean(id),
  });

  const wo = data?.workOrder as {
    id: string;
    displayNumber: string;
    title: string;
    description: string | null;
    severity: string;
    dueAt: string | null;
    hasUnitVisitLog: boolean;
    building: {
      name: string;
      addressLine1: string;
      city: string;
      state: string;
      postalCode: string;
    };
    unit: { label: string } | null;
  } | undefined;

  if (isLoading || !wo) {
    return <p className="text-sm text-muted">Loading…</p>;
  }

  const address = [wo.building.addressLine1, wo.building.city, wo.building.state, wo.building.postalCode]
    .filter(Boolean)
    .join(', ');

  return (
    <div className="space-y-4 pb-24">
      <Link to="/vendor/work" className="text-sm text-muted hover:text-fg">
        ← Back
      </Link>
      <div>
        <p className="text-xs text-muted">{wo.displayNumber}</p>
        <h1 className="text-lg font-semibold text-fg">{wo.building.name}</h1>
        {wo.unit ? <p className="text-sm text-muted">Unit {wo.unit.label}</p> : null}
        <p className="mt-1 text-sm text-muted">{address}</p>
      </div>
      <div className="flex items-center gap-2">
        <SeverityBadge level={wo.severity as 'medium'} subtle />
        <span className="text-sm font-medium text-fg">{wo.title}</span>
      </div>
      {wo.description ? <p className="text-sm text-muted">{wo.description}</p> : null}
      {wo.dueAt ? (
        <p className="text-sm text-muted">Due {new Date(wo.dueAt).toLocaleString()}</p>
      ) : null}

      <div className="fixed bottom-16 left-0 right-0 border-t border-border bg-surface p-4">
        {wo.hasUnitVisitLog ? (
          <Button asChild className="w-full min-h-12">
            <Link to={`/vendor/work/${wo.id}/units`}>Sign off units</Link>
          </Button>
        ) : (
          <Button asChild className="w-full min-h-12">
            <Link to={`/vendor/work/${wo.id}/signoff`}>Sign off completed work</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
